import {createSelector} from 'reselect';
import {selectSeatDetails} from '../../modules/react-sell-seat-details/selectors';
import {CONNECTIONS, ID_CONNECTIONS_MAP} from './connections-enum';

export const restrictionsAreValidSelector = createSelector(
  selectSeatDetails,
  (seatDetails) => seatDetails.restrictionsValid
);

export const limitationsAreValidSelector = createSelector(
  selectSeatDetails,
  (seatDetails) => seatDetails.limitationsValid
);

export const connectionsIsValidSelector = createSelector(
  selectSeatDetails,
  (seatDetails) => seatDetails.connectionsValid
);

const featuresSelector = createSelector(
  selectSeatDetails,
  ({features = []}) => features
);

const restrictionsSelector = createSelector(
  selectSeatDetails,
  ({restrictions = []}) => restrictions
);

const limitationsSelector = createSelector(
  selectSeatDetails,
  ({limitations = []}) => limitations
);

const connectionsSelector = createSelector(
  selectSeatDetails,
  ({connections = []}) => connections
);

export const connectionsMapperSelector = createSelector(
  connectionsSelector,
  (connections) => {
    if (connections.length === 0) {
      return CONNECTIONS.NO_CONNECTIONS;
    }
    if (connections.find(({id}) => CONNECTIONS.ORGANIZER === ID_CONNECTIONS_MAP[id])) {
      return CONNECTIONS.ORGANIZER;
    }
    if (connections.find(({id}) => CONNECTIONS.COMPANY === ID_CONNECTIONS_MAP[id])) {
      return CONNECTIONS.COMPANY;
    }
    if (connections.find(({id}) => CONNECTIONS.EMPLOYEE === ID_CONNECTIONS_MAP[id])) {
      return CONNECTIONS.EMPLOYEE;
    }
    return CONNECTIONS.UNKNOWN;
  }
);

export const featuresQuantitySelector = createSelector(
  featuresSelector,
  (features) => features.length
);

export const limitationsQuantitySelector = createSelector(
  limitationsSelector,
  (limitations) => limitations.length
);

export const restrictionsQuantitySelector = createSelector(
  restrictionsSelector,
  (restrictions) => restrictions.length
);
